import { memo, useCallback, useMemo } from 'react';

import { useCommandState } from '@air/cmdk';

import { SearchCommandGroup } from '~/components/SearchCommand/SearchCommandGroup';
import { SearchCommandSuggestionListItem } from '~/components/SearchCommand/SearchCommandSuggestionListItem';

export type SearchCommandSuggestionListProps = {
  onSelect: (suggestion: string) => void;
  suggestions?: string[];
};

export const SearchCommandSuggestionList = memo(({ suggestions, onSelect }: SearchCommandSuggestionListProps) => {
  const search = useCommandState((state) => state.search);

  const handleSelectSearch = useCallback(() => {
    onSelect(search);
  }, [onSelect, search]);

  const suggestionRows = useMemo(() => {
    if (!suggestions?.length) {
      return [];
    }

    if (search) {
      return suggestions.filter((suggestion) => suggestion !== search);
    }

    return suggestions;
  }, [search, suggestions]);

  if (!suggestionRows.length && !search) {
    return null;
  }

  return (
    <SearchCommandGroup heading={search ? undefined : 'Search suggestions'}>
      {!!search && <SearchCommandSuggestionListItem isCurrentQuery onSelect={handleSelectSearch} suggestion={search} />}

      {suggestionRows.map((suggestion) => (
        <SearchCommandSuggestionListItem key={suggestion} onSelect={onSelect} suggestion={suggestion} />
      ))}
    </SearchCommandGroup>
  );
});

SearchCommandSuggestionList.displayName = 'SearchCommandSuggestionList';
